module.exports = __webpack_public_path__ + "public/images/reviews/review-irina.b162662ee99e2cb9a00d1187ec8eacef.png";